export default __webpack_public_path__ + "static/media/bharat.37412825.png";